import { useEffect } from "react";

export default function ScrollOnTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
